// Product / order shape helpers.
// Products now support multiple VARIANTS. Each variant has:
//   { tag: 'Terracotta', stock: 5, images: ['url', 'url'] }
// Legacy products (with only top-level `stock` + `images`) are auto-wrapped
// into a single Default variant.

export function parseComboQty(val) {
  if (val == null || val === "") return 1;
  const num = Number(val);
  return (isNaN(num) || num < 1) ? 1 : num;
}

export function normalizeProduct(p) {
  if (!p) return p;
  const basePrice = Number(p.price || 0);
  const baseMrp = p.mrp != null && p.mrp !== "" ? Number(p.mrp) : basePrice;
  const shippingCharge = Number(p.shippingCharge || 0);

  // Costing structure (Fixed product cost + Fixed packaging cost + Extra charge)
  const productCost = p.productCost != null && p.productCost !== "" ? Number(p.productCost) : (p.costPrice != null ? Number(p.costPrice) : Math.round(basePrice * 0.45));
  const packagingCost = p.packagingCost != null && p.packagingCost !== "" ? Number(p.packagingCost) : 80;
  const extraCharge = Number(p.extraCharge || 0);
  const gstRate = p.gstRate != null && p.gstRate !== "" ? Number(p.gstRate) : 0;

  let variants = p.variants;
  if (!Array.isArray(variants) || variants.length === 0) {
    variants = [{
      tag: "Default",
      stock: Number(p.stock ?? 0),
      comboQty: 1,
      price: basePrice,
      mrp: baseMrp,
      productCost,
      packagingCost,
      extraCharge,
      images: p.images || []
    }];
  } else {
    variants = variants.map((v) => {
      const vPrice = v.price != null && v.price !== "" ? Number(v.price) : basePrice;
      const vMrp = v.mrp != null && v.mrp !== "" ? Number(v.mrp) : (vPrice > basePrice ? vPrice : baseMrp);
      const vProductCost = v.productCost != null && v.productCost !== "" ? Number(v.productCost) : productCost;
      const vPackagingCost = v.packagingCost != null && v.packagingCost !== "" ? Number(v.packagingCost) : packagingCost;
      const vExtraCharge = v.extraCharge != null && v.extraCharge !== "" ? Number(v.extraCharge) : extraCharge;
      const comboQty = parseComboQty(v.comboQty || v.packQty || v.quantity);
      return {
        ...v,
        stock: Number(v.stock ?? 0),
        comboQty,
        price: vPrice,
        mrp: vMrp,
        productCost: vProductCost,
        packagingCost: vPackagingCost,
        extraCharge: vExtraCharge,
        images: v.images || []
      };
    });
  }
  const stock = variants.reduce((s, v) => s + Number(v.stock || 0), 0);
  const images = variants.flatMap((v) => v.images || []);
  return {
    ...p,
    price: basePrice,
    mrp: baseMrp,
    shippingCharge,
    productCost,
    packagingCost,
    extraCharge,
    gstRate,
    size: p.size || p.dimensions || "",
    weight: p.weight || "",
    bagType: p.bagType || p.type || "",
    colour: p.colour || p.color || "",
    material: p.material || "",
    description: p.description || "",
    variants,
    stock,
    images
  };
}

export function primaryImage(product) {
  const norm = normalizeProduct(product);
  const v0 = norm?.variants?.[0];
  return v0?.images?.[0] || norm?.images?.[0] || "";
}

export const isSoldOut = (p) => Number(p?.stock || 0) <= 0;
